export default {
  props: {
    firstStep: {
      type: Function,
      default: undefined,
    },
    nextStep: {
      type: Function,
      default: undefined,
    },
    prevStep: {
      type: Function,
      default: undefined,
    },
    finishStep: {
      type: Function,
      default: undefined,
    },
  },
}
